import React from "react";
import PropTypes from "prop-types";

// It's depricatred but used
// new one is PopoverMenuOption
// stop a pochemu depricated to . ?
// navernoe tam OPTION peredaetsya a ne prosps raznie

// use PopoverMenuOption - and yes you need create oiption but it's actully good


type Props = {
    className?          : string
    label               : string
    icon?               : string
    iconComponent?      : any

    selected?           : boolean
    checkPro?           : boolean
    disabled?           : boolean
    isHighlighted?      : boolean
    isLink?             : boolean

    onMouseEnter?       : callback
    onMouseLeave?       : callback
    onClick?            : callback
    onClickDisabled?    : callback
    onClickUpgrade?     : callback
}

export default function PopoverMenuItem(props: Props) {

    const isPro = !props.checkPro || gd.session.companies.get(gd.companyId).license.isPro;

    const classes = Classes('option', props.className, {
        'with-icon'     : props.icon,
        'disabled'      : props.disabled,
        'selected'      : props.selected,
        'highlighted'   : props.isHighlighted,
        'is-link'       : props.isLink,
    });

    const labelClasses = Classes('label', {
        'bold': props.selected
    })

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();

        if (props.disabled) {
            props.onClickDisabled && props.onClickDisabled();
        } else {
            isPro ? props.onClick && props.onClick() : props.onClickUpgrade && props.onClickUpgrade();
        }
    };

    return (
        <div className={classes} onClick={onClick} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave}>
            {props.icon && <div className={Classes("ico", props.icon)}/>}
            {props.iconComponent}
            <div className={labelClasses}>{props.label}</div>
            {!isPro && <div className="ui5-ico-pro"/>}
        </div>
    );
}
